import { RouterProvider } from "react-router";
import { Suspense, useEffect, useRef } from "react";
import { router } from "./routes.tsx";
import { ThemeProvider } from "../contexts/ThemeContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { trackPageView } from "@/lib/analytics";

function LoadingFallback() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#FBF9F6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ width: '240px', textAlign: 'center' }}>
        <p style={{
          fontSize: '10px',
          color: 'rgba(65,47,33,0.6)',
          textTransform: 'uppercase',
          letterSpacing: '0.2em',
          marginBottom: '12px'
        }}>
          Loading travels...
        </p>
        <div style={{
          height: '2px',
          backgroundColor: 'rgba(65,47,33,0.1)',
          borderRadius: '2px',
          overflow: 'hidden'
        }}>
          <div style={{
            height: '100%',
            width: '40%',
            backgroundColor: 'rgba(65,47,33,0.4)',
            animation: 'loading 1.5s ease-in-out infinite',
          }} />
        </div>
      </div>
      <style>{`
        @keyframes loading {
          0%, 100% { transform: translateX(-100%); }
          50% { transform: translateX(250%); }
        }
      `}</style>
    </div>
  );
}

function usePageTracking() {
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    const unsubscribe = router.subscribe((state) => {
      const currentPath = state.location.pathname;
      if (currentPath !== previousPath.current) {
        trackPageView(currentPath);
        previousPath.current = currentPath;
      }
    });
    return unsubscribe;
  }, []);
}

export default function App() {
  usePageTracking();

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Suspense fallback={<LoadingFallback />}>
          <RouterProvider router={router} />
        </Suspense>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
